/* eslint-disable import/no-unresolved */
import { datadogRumConfig } from "config";
/* eslint-enable import/no-unresolved */

import { datadogRum } from "@datadog/browser-rum";

export default function initDatadogRum() {
  // すでに初期化済みの場合は初期化処理をスキップする
  if (!datadogRum.getInitConfiguration()) {
    if (datadogRumConfig && Object.keys(datadogRumConfig).length > 0) {
      datadogRum.init(datadogRumConfig);
    }
  }

  // 初期化済みかどうかにかかわらず、UserIDの設定を行う
  if (window.fincUserId) {
    datadogRum.setUser({
      id: window.fincUserId,
      type: window.fincUserType
    });
  }
}
